import fetchAPI from '../utils/fetchAPI';

export default ({ xsrfToken, bundleType }: { xsrfToken: string; bundleType: string }) =>
  fetchAPI({
    method: 'POST',
    url: `/smb-profile/api/bundle/${bundleType}`,
    xsrfToken,
  });
